<div class="main-view">
  <mat-card>
    <mat-card-content>
      <div class="flex-space-between">
        <div class="flex">
          <mng-inputfield-date-range
            label="Übernahmedatum"
            subscriptSizing="dynamic"
            [field]="laborUi.field('vonDatum')"
            [bisDatumField]="laborUi.field('bisDatum')"
            [max]="heuteDatum"
          />
          <mng-inputfield-string-clearable subscriptSizing="dynamic" [field]="laborUi.field('code')" />
          @if (!laborUi.field('code').control.value) {
            <mng-inputfield-select
              subscriptSizing="dynamic"
              [smallOptionText]="true"
              [field]="laborUi.field('statusId')"
            />
          }

          @if (!isAdmin() && isArzt()) {
            <mng-inputfield-boolean [field]="laborUi.field('allePartnerUntersuchungen')" />
          }

          @if (isAdmin()) {
            <mng-mgs-partner-auswahl
              [ngStyle]="{ width: '350px' }"
              [updateRoute]="false"
              (partnerSelection)="onPartnerSelection($event)"
            />
          }
        </div>
        <div class="flex">
          <button mat-raised-button color="accent" (click)="aktualisieren()">Aktualisieren</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="text-background" style="padding-left: 10px" [innerHtml]="service.paramsAsHtmlString()"></div>

  @if (gridOptions) {
    <mng-tabulator [gridOptions]="gridOptions" (tableCreatedEvent)="onTableCreatedEvent($event)" />
  }
</div>
